export default __webpack_public_path__ + "static/media/background.b10b126a.jpg";